import styled from 'styled-components';

export const Header = styled.header`
  width: 90%;
  height: 70px;
  background: #fff;
  margin-left: 1.5%;
  border-radius: 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  button {
    background: none;
    border: 0;
  }
`;

export const Container = styled.div`
  width: 88%;
  background: #fff;

  margin-top: 10px;
  margin-left: 2.5%;

  padding: 20px;

  h2 {
    padding-left: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  h3 {
    padding-left: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  h4 {
    padding-left: 30px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  p,
  a {
    padding-left: 40px;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

export const Card = styled.div`
  width: 90%;
  margin-left: 5%;
  padding: 20px;
  background: #eee;
`;

export const Challenge = styled.div`
  width: 90%;
  margin-left: 5%;
  padding: 20px;
  background: #eee;
`;

export const Main = styled.div`
  width: 100%;
  padding: 20px;
  background: #ddd;

  margin-bottom: 10px;
`;
